import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9980c9ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "worp" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "推流地址：", -1))
const _hoisted_4 = {
  key: 0,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "低延迟开关：", -1))
const _hoisted_6 = { class: "frame" }
const _hoisted_7 = {
  key: 0,
  class: "tag reality"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "frame"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag vr" }, "VR", -1))
const _hoisted_11 = { class: "container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container_right" }, [
  /*#__PURE__*/_createElementVNode("p", null, "建议直播网络上行宽带码率的3倍以上"),
  /*#__PURE__*/_createElementVNode("p", null, "如：码率1500kbps,则推荐上行网络宽带不少于5M")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { message, Popover, Input, Button, Switch, Modal, Tooltip, Checkbox } from 'ant-design-vue';
import ClipboardJS from 'clipboard';
import { QuestionCircleFilled, ExclamationCircleFilled } from '@ant-design/icons-vue';
import { useConsoleStore } from '@/pinia/console';
import { createVNode, computed, ref } from 'vue';
import http from '@/api';
import router from '@/router';
import { useHomeStore } from '@/pinia/home';
import { useStore } from 'vuex';
import { watch } from 'vue';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { string } from 'vue-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'PushLive',
  setup(__props) {

const store = useStore();
const VRLiveRole = computed(() => homeStore.funcData?.panoramaLive); // VR直播权限
const studioId = router.currentRoute.value.params.studioId;
const consoleStore = useConsoleStore();
const aPopover = Popover;
const aInput = Input;
const aButton = Button;
const aSwitch = Switch;
const aTooltip = Tooltip;
const aCheckboxGroup = Checkbox.Group;

const homeStore = useHomeStore();
const lowLatencyRole = computed(() => homeStore.funcData?.lowLatency);
const pushUrl = computed(() => consoleStore.consoleInfo.pushUrl[0]);
const vrPushUrl = computed(() => consoleStore.consoleInfo.vrPushUrl[0]);
const copy = (btns: string) => {
  const ClipboardJSObj = new ClipboardJS(btns);
  ClipboardJSObj.on('success', (e) => {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
    ClipboardJSObj.destroy();
  });
  ClipboardJSObj.on('error', () => {
    message.destroy();
    message.info('复制失败');
    ClipboardJSObj.destroy();
  });
};

const onLowLatency = () => {
  Modal.confirm({
    centered: true,
    icon: () => createVNode(ExclamationCircleFilled),
    content: () => `确认${consoleStore.consoleInfo.pushType ? '关闭' : '开启'}低延迟开关?`,
    onOk() {
      return new Promise((resolve, reject) => {
        message.destroy();
        const data = {
          studio_id: studioId,
          low_latency: consoleStore.consoleInfo.pushType ? 0 : 1,
        };
        http.liveMode
          .setLowLatency(data)
          .then((res) => {
            message.success(res.data.message);
            consoleStore.getConsoleInfo(Number(studioId as string));
            resolve({});
          })
          .catch((err) => {
            message.error(err.data.error);
            reject(err);
          });
      });
    },
    onCancel() {
      // consoleStore.consoleInfo.pushType = !consoleStore.consoleInfo.pushType;
    },
  });
};

const isShow3D = computed(() => consoleStore.consoleInfo.vrPlayStatus === 1 || consoleStore.consoleInfo.vrPlayStatus === 2);
const onChange3D = () => {
  Modal.confirm({
    centered: true,
    icon: () => createVNode(ExclamationCircleFilled),
    content: () => `确认${consoleStore.consoleInfo.vrPlaySwitch ? '关闭' : '开启'}仅支持3D开关?`,
    onOk() {
      return new Promise((resolve, reject) => {
        message.destroy();
        const data = {
          studio_id: studioId,
          status: consoleStore.consoleInfo.vrPlaySwitch ? 0 : 1,
        };
        http.liveMode
          .setVrPlaySwitch(data)
          .then(async (res) => {
            await consoleStore.getConsoleInfo(Number(studioId as string));
            resolve({});
          })
          .catch((err) => {
            message.error(err.data.error);
            reject(err);
          });
      });
    },
    onCancel() {
      // consoleStore.consoleInfo.pushType = !consoleStore.consoleInfo.pushType;
    },
  });
};

const clickRefresh = () => {
  http.live
    .refreshPushPlay({ studio_id: studioId })
    .then((res) => {
      consoleStore.consoleInfo.pushUrl[0] = res.data.data.push_url;
      message.success(res.data.message);
    })
    .catch((err) => message.error(err.data.error));
};

const customData = computed(() => store.state.home.customData);
const streamStatus = ref<any>();
const checkClick = useDebounce(() => {
  const data = {
    studio_id: studioId,
    stream_status: consoleStore.consoleInfo.streamStatus.join(','),
  };
  http.liveMode
    .setVrPlaySwitch(data)
    .then((res) => {
      console.info(res);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
});

watch(
  () => consoleStore.consoleInfo.streamStatus,
  (newVal: any, oldVal) => {
    streamStatus.value = newVal;
    if (newVal.length == 0) {
      message.destroy();
      message.info('至少选择一个！');
      consoleStore.consoleInfo.streamStatus = oldVal;
      return;
    } else if (oldVal != '') {
      checkClick();
    }
    // if (newVal.length == '') {
    //   message.destroy();
    //   message.info('至少选择一个！');
    //   consoleStore.consoleInfo.streamStatus = oldVal
    //   return
    // }else{
    //   console.log(11);
    //   checkClick()
    // }
    return;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        (_unref(VRLiveRole) && _unref(consoleStore).consoleInfo.mode == 0)
          ? (_openBlock(), _createBlock(_unref(aCheckboxGroup), {
              key: 0,
              value: _unref(consoleStore).consoleInfo.streamStatus,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(consoleStore).consoleInfo.streamStatus) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_checkbox, { value: "0" }, {
                  default: _withCtx(() => [
                    _createTextVNode("2D")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_checkbox, { value: "1" }, {
                  default: _withCtx(() => [
                    _createTextVNode("VR")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      (_unref(lowLatencyRole) && !_unref(isShow3D))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createTextVNode("  "),
            _createVNode(_unref(aSwitch), {
              checked: _unref(consoleStore).consoleInfo.pushType,
              disabled: _unref(consoleStore).consoleInfo.liveUrlStatus === 1,
              onChange: onLowLatency,
              size: "small"
            }, null, 8, ["checked", "disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      (_unref(isShow3D) || _unref(consoleStore).consoleInfo.streamStatus != true)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "2D"))
        : _createCommentVNode("", true),
      _createVNode(_unref(aInput), {
        id: "pushInput",
        value: _unref(pushUrl),
        readonly: ""
      }, null, 8, ["value"]),
      (_unref(customData).refresh_status)
        ? (_openBlock(), _createBlock(_unref(aButton), {
            key: 1,
            class: "text",
            onClick: clickRefresh
          }, {
            default: _withCtx(() => [
              _createTextVNode("刷新")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(aButton), {
        class: "text",
        "data-clipboard-target": "#pushInput",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (copy('.text')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("复制")
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, _unref(consoleStore).consoleInfo.streamStatus != true || !_unref(VRLiveRole)]
    ]),
    (_unref(consoleStore).consoleInfo.streamStatus != false && _unref(VRLiveRole))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_unref(isShow3D) && _unref(vrPushUrl))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_unref(aInput), {
                  id: "vr_push_input",
                  value: _unref(vrPushUrl),
                  readonly: ""
                }, null, 8, ["value"]),
                (_unref(customData).refresh_status)
                  ? (_openBlock(), _createBlock(_unref(aButton), {
                      key: 0,
                      class: "text",
                      onClick: clickRefresh
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("刷新")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(aTooltip), {
                  title: "请注意3D推流的画布尺寸",
                  color: "orange"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(aButton), {
                      class: "text",
                      "data-clipboard-target": "#vr_push_input",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (copy('.text')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("复制")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_unref(aButton), {
        type: "primary",
        href: "https://www.speedtest.cn/",
        target: "block"
      }, {
        default: _withCtx(() => [
          _createTextVNode("立即测试网络")
        ]),
        _: 1
      }),
      _hoisted_12,
      _createVNode(_unref(aPopover), { placement: "left" }, {
        content: _withCtx(() => [
          _createTextVNode(" 建议： 1. 1080P（1920x1080）25fps，建议码率2500kbps。"),
          _hoisted_13,
          _createTextVNode("     2. 720P（1280x720）25fps，建议码率1200kbps。"),
          _hoisted_14,
          _createTextVNode("     3. 540P（960x540）25fps，建议码率600kbps。 ")
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(QuestionCircleFilled), { class: "icon" })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})